const funcion = {
  IniciarSesion: 'Login/IniciarSesion',
  ValidarLaSesionIniciada: 'Login/ValidarLaSesionIniciada',
  ObtenDatosGeneralesDeLaSesion: 'Login/ObtenDatosGeneralesDeLaSesion',
  ValidaYObtenPermisosDelSistema: 'Login/ValidaYObtenPermisosDelUsuarioEnElSistema',
  ValidaQueElUsuarioTengaPermisoParaVerLaVentana: 'Login/ValidaQueElUsuarioTengaPermisoParaVerLaVentana'
}

export default funcion;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/login/funcion/funcion.js
// module id = null
// module chunks = 